import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Coa1 from "../../../containers/modules/accounting/coa1";

export default function Coa1Route(props) {
  const { authUser } = props;
  return (
    <Route
      path="coa1"
      index
      element={
        <AccessControl
          name={"Coa1 List"}
          auth={authUser}
          component={() => <Coa1 />}
        />
      }
    />
  );
}
